var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-full-a", attrs: { id: "category" } }, [
    _c(
      "div",
      {
        staticClass: "admin-content-area",
        attrs: { id: "page-content-wrapper" }
      },
      [
        _c("div", { staticClass: "container-fluid xyz" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(
              "\n                Draggable Wellness Slider Image List\n                "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addWellnessSlider.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Add")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "admin-page-content" },
            [
              _c(
                "draggable",
                {
                  staticClass: "drag-view",
                  on: {
                    change: function($event) {
                      return _vm.changePosition()
                    }
                  },
                  model: {
                    value: _vm.imageList,
                    callback: function($$v) {
                      _vm.imageList = $$v
                    },
                    expression: "imageList"
                  }
                },
                [
                  _vm._l(_vm.imageList, function(text, index) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "btn edit-btn-vvg waves-effect" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    title: "Edit Wellness Slider",
                                    to: {
                                      name: "UpdateWellnessSlider",
                                      params: { id: text.id }
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    key: index,
                                    staticClass: "img-rounded",
                                    attrs: { src: text.image }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger deleteMedia",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.deleteWellnessSliderImage(text.id)
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-trash",
                                attrs: { "aria-hidden": "true" }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("app-backend-footer")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aff0a8dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aff0a8dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/wellnessslider/ListWellnessSlider.vue
// module id = null
// module chunks = 